import { relationGroupsConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { addRelationGroupLoading: true, data: '', error: false };

export function addRelationGroup(state = initialState, action) {
 
  switch (action.type) {
    case relationGroupsConstants.REQUEST_ADD_RELATION_GROUP:
      return {
        addRelationGroupLoading: true,
        data: '',
        error: false
      };
    case relationGroupsConstants.RECEIVE_ADD_RELATION_GROUP:
      swal({
        text: "Relation Group Added Successfully!",
        type: "success",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
      return {
        addRelationGroupLoading: false,
        data: action.relationGroup,
        error: false
      };
    case relationGroupsConstants.ADD_RELATION_GROUP_ERROR:
 
    swal({
      text: action.error.response.data.errors.relation_group_name[0],
      type: "error",
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK'
    })
      return {
        addRelationGroupLoading: false,
        data: action.error,
        error: true
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/relationGroups/addRelationGroup.reducer.js